import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoEstadoRelacionNotificacion } from '../_models/producto-estado-relacion-notificacion';

@Injectable({
  providedIn: 'root'
})
export class ProductoEstadoRelacionNotificacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosEstadosRelacionesNotificaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }

  listadoPorProductoEstadoRelacionHabilitado( idProductoEstadoRelacion: string ) {
    return this.httClient.get( this.rutServicio + '/productoEstadoRelacion/' + idProductoEstadoRelacion + '/enabled' ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }

  listadoPorProductoEstadoRelacion( idProductoEstadoRelacion: string ) {
    return this.httClient.get( this.rutServicio + '/productoEstadoRelacion/' + idProductoEstadoRelacion ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }

  listadoPorProductoEstado( idProductoEstado: string ) {
    return this.httClient.get( this.rutServicio + '/productoEstado/' + idProductoEstado ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoEstadoRelacionNotificacion ) );
  }

  crear( regCrear: ProductoEstadoRelacionNotificacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoEstadoRelacionNotificacion ) );
  }

  actualizar( regActualizar: ProductoEstadoRelacionNotificacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoEstadoRelacionNotificacion[] ) {
    regActualizar.map( ( s: ProductoEstadoRelacionNotificacion ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as ProductoEstadoRelacionNotificacion[] ) );
  }
}
